// redux/reducers/categoryModalReducer.js
const initialState = {
    isModalVisible: false,
  };
  
  const blogModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_BLOG_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_BLOG_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default blogModalReducer;
  